// extracted by mini-css-extract-plugin
export default {"btn__send":"EmailRecovery_btn__send__xqjpk","card__footer__link":"EmailRecovery_card__footer__link__V19MB"};